import {
  assign, endpoint, check, convert,
} from '../helpers';
import { User } from '../../tools';

/**
 * Loads the exported report schema into the server
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const upload = (properties) => {
  const props = assign(properties);
  const xhr = new XMLHttpRequest();

  xhr.open('POST', endpoint(`/${User.getToken()}/UploadFile?${props.data.params}`, 'media'), true);
  xhr.setRequestHeader('Content-length', props.data.files.size);

  xhr.onreadystatechange = () => {
    if (xhr.readyState === 4 && xhr.status === 200) {
      const response = JSON.parse(xhr.responseText);
      check(response.Token);
      if (response.Success) {
        props.success(convert(response.Message));
      } else {
        props.error(convert(response.Message));
      }
    }
  };

  xhr.send(props.data.files);
};

export default upload;
